import React, { Component } from "react";
import { Box, Alert, IconButton } from "@mui/material";
import { Filter, Table, DialogDetails } from "./components";
import { VisibleContent } from "../../components";
import agent from "../../agent/agent";
import { RouterContext } from "../../layouts/CabinetLayout";
import { connect } from "react-redux";

const initFilter = {
  license_plate: "",
  complex_serial: "",
  is_recognized: null,
  datetime_start: null,
  datetime_end: null,
  page: 1,
  limit: 15,
};

class HiddenGrz extends Component {
  static contextType = RouterContext;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      filter: { ...initFilter },
      errorMessage: "",
      totalPages: 1,
      totalCount: 0,
      isLoading: true,
      contractId: null,
    };
    this.refDialogDetails = React.createRef();
  }

  componentDidMount = async () => { await this.initState(); };
  componentDidUpdate = async (prevProps) => {
    const prevId = prevProps.contract?.available_contracts?.contract_id;
    const currentId = this.props.contract?.available_contracts?.contract_id;
    if (prevId !== currentId) {
      await this.setState({ isLoading: true });
      await this.initState();
    }
  };
  initState = async () => {
    const contractId = this.props?.contract?.available_contracts?.contract_id;
    await this.setState({ contractId });
    await this.initFilter();
  };

  getItems = async () => {
    await this.setState({ isLoading: true, errorMessage: "" });
    const filter = this.getFilter();
    const res = await agent.get(`/operator/trucks?${filter}`).then((r) => r).catch((err) => ({ error: err?.response }));
    if (res?.error) {
      await this.setState({ isLoading: false, errorMessage: res?.error?.data?.details || "" });
      return;
    }
    const data = res?.data?.data || [];
    if (data.length <= 0) {
      await this.setState({ isLoading: false, errorMessage: "Нет данных" });
      return;
    }
    const totalCount = Number.parseFloat(res?.headers?.["x-pagination-total-count"] || "0");
    const totalPages = Math.ceil(totalCount / (this.state.filter?.limit || 20));
    await this.setState({ isLoading: false, totalPages, totalCount, items: data });
    this.updateUrlSearch();
  };

  getFilter = () => {
    let filterSrt = [`contract_id=${this.state.contractId}`];
    const filter = this.state.filter;
    Object.keys(filter).forEach((key) => {
      const value = filter[key];
      if (key === "is_recognized") {
        if (typeof value === "boolean") filterSrt.push(`${key}=${value}`);
      } else if (!!value) {
        filterSrt.push(`${key}=${value}`);
      }
    });
    return filterSrt.filter((t) => !!t).join("&");
  };
  initFilter = async () => {
    const search = new URLSearchParams(window.location.search);
    const parsedFilter = { ...initFilter };
    for (const [key, value] of search.entries()) {
      if (key in initFilter) {
        if (["license_plate", "complex_serial"].includes(key)) parsedFilter[key] = value;
        else if (["page", "limit"].includes(key)) { const n = parseInt(value, 10); if (!isNaN(n)) parsedFilter[key] = n; }
        else if (["datetime_start", "datetime_end"].includes(key)) parsedFilter[key] = value || null;
        else if (key === "is_recognized") {
          if (value === "true" || value === "1") parsedFilter[key] = true;
          else if (value === "false" || value === "0") parsedFilter[key] = false;
          else parsedFilter[key] = null;
        }
      }
    }
    await this.setState({ filter: parsedFilter }, async () => { await this.getItems(); });
  };
  resetFilter = async () => { await this.setState({ filter: { ...initFilter } }); await this.getItems(); };
  changeFilter = async (filter, isFastState = false) => { await this.setState({ filter }); if (!isFastState) return; await this.getItems(); };
  updateUrlSearch = () => {
    const { filter } = this.state;
    const searchParams = new URLSearchParams();
    Object.keys(filter).forEach((key) => {
      const value = filter[key];
      const defaultValue = initFilter[key];
      if (value === defaultValue) return;
      if (value !== null && value !== undefined && value !== "") searchParams.set(key, value.toString());
    });
    const newSearch = searchParams.toString();
    const newUrl = newSearch ? `${this.context.location.pathname}?${newSearch}` : this.context.location.pathname;
    this.context.navigate(newUrl, { replace: true });
  };

  openDetails = (item) => { this.refDialogDetails.current.open(item); };

  render() {
    const { items, filter, isLoading, totalPages, totalCount, errorMessage } = this.state;
    const isError = Boolean(errorMessage);

    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* Хэдер */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 500, lineHeight: "28px", color: "#111111" }}>Скрытые ГРЗ</h1>
            {totalCount > 0 && (
              <span style={{ fontSize: 12, fontWeight: 500, lineHeight: "18px", color: "#432DD7", backgroundColor: "#E0E7FF", borderRadius: 16, padding: "2px 8px" }}>
                {totalCount.toLocaleString('ru-RU')}
              </span>
            )}
            <IconButton onClick={this.getItems} size="small" sx={{ color: "#4F39F6" }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 3.125 13.5 3.125 13.5M3.125 13.5H6.25M3.125 13.5V17M2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.8438 2.5 17.5 6.5 17.5 6.5M17.5 6.5V3M17.5 6.5H14.375" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </IconButton>
          </Box>
        </Box>

        {/* Фильтры */}
        <Filter
          filter={filter}
          onSearch={this.getItems}
          onReset={this.resetFilter}
          onChange={this.changeFilter}
        />

        {/* Таблица */}
        <VisibleContent visible={!isError}>
          <Table
            items={items}
            filter={filter}
            isLoading={isLoading}
            totalPages={totalPages}
            totalCount={totalCount}
            onSearch={this.getItems}
            onChangeFilter={this.changeFilter}
            onOpenDetails={this.openDetails}
          />
        </VisibleContent>
        <VisibleContent visible={isError}>
          <Alert variant="filled" color="error">{errorMessage}</Alert>
        </VisibleContent>

        <DialogDetails ref={this.refDialogDetails} />
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({ contract: state.contracts?.contract || null });
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(HiddenGrz);
